import React from 'react';
import ChangePasswordForm from '../../forms/ChangePassword';
import centredForm from '../components/centredForm';
import { Trans } from 'react-i18next';

export default centredForm(
  ChangePasswordForm,
  <Trans>resetPasswordNewPasswordTitle</Trans>,
  350
);



// WEBPACK FOOTER //
// ./src/view/scenes/ChangePassword/index.js